import React, { useEffect, useState } from "react";
import { ticketsActivityLog } from "../../../services/TicketsServices";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import Moment from "react-moment";
import { useParams } from "react-router";
import { Drawer } from "@mui/material";
import Card from "@mui/material/Card";

export default function TicketsAduitTrial(props) {
  const { openLog, handleLogClose } = props;
  const params = useParams();
  const id = params?.id;
  const [task, setTask] = useState([]);

  useEffect(() => {
    if (id) getTicketActivityLog();
  }, [id]);

  const getTicketActivityLog = () => {
    ticketsActivityLog("get", id).then((res) => {
      setTask(res?.data);
    });
  };

  return (
    <Drawer
      open={openLog}
      anchor="right"
      onClose={handleLogClose}
      BackdropProps={{ style: { backgroundColor: "rgba(0, 0, 0, 0)" } }}
      sx={{
        "& .MuiDrawer-paper": {
          boxSizing: "border-box",
          width: "30%",
          height: "calc(100% - 87px)",
          top: 87,
          backgroundColor: "#F4F7FC",
          borderTopLeftRadius: 12,
          borderBottomLeftRadius: 12,
        },
      }}
    >
      {/* Header */}
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        sx={{
          px: 3,
          py: 2,
          borderBottom: "1px solid #E5E7EB",
          background: "#fff",
        }}
      >
        <Typography
          sx={{
            fontSize: 20,
            fontWeight: 600,
            color: "#1E293B",
          }}
        >
          Audit Trail
        </Typography>

        <IconButton onClick={handleLogClose}>
          <CloseRoundedIcon />
        </IconButton>
      </Box>

      {/* Body */}
      <Box
        sx={{
          p: 2,
          overflowY: "auto",
          height: "100%",
        }}
      >
        {task && task.length > 0 ? (
          task.map((log, index) => (
            <Card
              key={index}
              elevation={2}
              sx={{
                mb: 2,
                p: 2,
                borderRadius: 3,
                borderLeft: "5px solid #616B88",
              }}
            >
              <Typography
                sx={{
                  fontSize: 15,
                  fontWeight: 600,
                  color: "#1F2937",
                  mb: 1,
                }}
              >
                {log.state === "completed" ? (
                  <>
                    Created By: <strong>{log.by_name}</strong>
                  </>
                ) : (
                  <>
                    Scanned By: <strong>{log.by_name}</strong>
                  </>
                )}
              </Typography>

              <Box
                sx={{
                  display: "inline-block",
                  px: 1.5,
                  py: 0.5,
                  borderRadius: "20px",
                  backgroundColor:
                    log.state === "completed"
                      ? "#E8F5E9"
                      : "#E3F2FD",
                  color:
                    log.state === "completed"
                      ? "#2E7D32"
                      : "#1565C0",
                  fontSize: 13,
                  fontWeight: 600,
                  mb: 1.5,
                }}
              >
                {log.state}
              </Box>

              <Typography
                sx={{
                  fontSize: 13,
                  color: "#6B7280",
                }}
              >
                <Moment format="MMMM Do YYYY, h:mm:ss a">
                  {log.timestamp}
                </Moment>
              </Typography>
            </Card>
          ))
        ) : (
          <Box
            sx={{
              height: "80%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Typography
              sx={{
                color: "#9CA3AF",
                fontSize: 15,
              }}
            >
              No activity logs available
            </Typography>
          </Box>
        )}
      </Box>
    </Drawer>
  );
}
